import { Result } from './Result';

export default class StringResult extends Result<string> {
    public data: string | null = null;
}
